import { useState, useEffect } from 'react'
import { 
    Container, 
    Card, 
    Grid, 
    Box, 
    Typography, 
    CircularProgress,
    Alert
} from '@mui/material'

export default function UserLicences(props) {
    const [licences, setLicences] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    // Função para buscar as licenças
    const fetchLicences = async () => {
        setIsLoading(true)
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/licences/client/licences?serialNumber=${props.serialKeys}`, {
                method: 'GET',
                headers: {
                    "content-type": "application/json",
                    "Authorization": "Bearer " + props.token
                }
            });
            const data = await response.json();
            setLicences(data);
            
            const webLicence = data.find(item => item.tipo_licenca === 'web');
            if (webLicence) {
                props.setWebUsers(webLicence.quantidade_usuarios);
            }
        } catch (error) {
            console.error("Error fetching licences:", error);
        } finally {
            setIsLoading(false)
        }
    };

    // Atualizar quando o trigger mudar
    useEffect(() => {
        fetchLicences();
    }, [props.updateTrigger]);

    return (
        <>            
            <Typography variant="h6" sx={{ marginTop: '1rem', marginBottom: '0.5rem', color: '#5ACBFA', fontWeight: 700 }}>Licenças Encontradas</Typography>

            <Box sx={{
                background: 'linear-gradient(135deg, rgba(52,152,219,0.2) 0%, rgba(44,62,80,0.8) 100%)',
                border: '1px solid rgba(52,152,219,0.4)',
                borderRadius: '12px 12px 0 0',
                padding: '8px 16px'
            }}>
                <Grid container spacing={3}>
                    <Grid item xs={3} md={3} lg={3}>
                        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.85)', fontWeight: 600 }}>Tipo de Licença</Typography>
                    </Grid>
                    <Grid item xs={4} md={4} lg={4}>
                        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.85)', fontWeight: 600 }}>Chave</Typography>
                    </Grid>
                    <Grid item xs={3} md={3} lg={3}>
                        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.85)', fontWeight: 600 }}>Validade</Typography>
                    </Grid>
                    <Grid item xs={2} md={2} lg={2}>
                        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.85)', fontWeight: 600 }}>Status</Typography>
                    </Grid>
                </Grid>
            </Box>
            {isLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '2rem' }}>
                    <CircularProgress color="secondary" />
                </Box>
            )
            :
            (licences.length > 0 ? (
                licences.map(item => {
                    return <Card sx={{
                        background: 'linear-gradient(135deg, rgba(26,37,47,0.97) 0%, rgba(44,62,80,0.97) 100%)',
                        border: '1px solid rgba(52,152,219,0.2)',
                        borderTop: 'none',
                        borderRadius: 0,
                        padding: '1rem',
                        textAlign: 'center',
                        '&:last-child': { borderRadius: '0 0 12px 12px' },
                        '&:hover': { borderColor: 'rgba(52,152,219,0.5)', backgroundColor: 'rgba(52,152,219,0.05)' }
                    }} key={item.chave}>
                        <Grid container spacing={3}>
                            <Grid item xs={3} md={3} lg={3}>
                                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)' }}>{item.tipo_licenca == "desktop" ? "PRO Local" : item.tipo_licenca}</Typography>
                            </Grid>
                            <Grid item xs={4} md={4} lg={4}>
                                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)' }}>{item.chave}</Typography>
                            </Grid>
                            <Grid item xs={3} md={3} lg={3}>
                                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)' }}>{new Date(item.expiracao_licenca).toLocaleDateString()}</Typography>
                            </Grid>
                            <Grid item xs={2} md={2} lg={2}>
                                <Typography variant="body2" sx={{ color: item.chave_utilizada ? '#34C759' : 'rgba(255,255,255,0.5)' }}>{item.chave_utilizada ? "Ativada" : "Não Ativada"}</Typography>
                            </Grid>
                        </Grid>
                    </Card>
                })
            ) : (
                <Typography variant="body2" align="center" sx={{ mt: 2 }}>Nenhuma licença encontrada</Typography>
            ))
            }
        </>
    )
}